<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <div v-if="modal" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all md:w-auto sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="max-height: 70vh;">
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                    <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
                        <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="claim">
                            DOCUMENTOS A FIRMAR ({{ claim.code }})
                        </h3>
                        <div class="flex flex-col px-10 xl:px-0">
                          <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                            <input type="text" v-model="name" placeholder="Nombre" class="text-sm w-full form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                {{ errors.name }}
                            </span>
                          </div>
                        </div>

                        <div class="flex flex-col px-10 xl:px-0">
                          <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                            <input type="file" class="text-sm w-full form-input py-2 appearance-none rounded-md focus:border-indigo-600" @change="handleFile" ref="inputFile" accept="application/pdf">
                            <span class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                                {{ errors.file }}
                            </span>
                          </div>
                        </div>

                        <div class="flex flex-col px-10 xl:px-0">
                          <div class="flex flex-col px-10 xl:px-0 pt-2 pb-2">
                            <textarea rows="2" class="text-sm w-full form-input py-2 appearance-none rounded-md focus:border-indigo-600" placeholder="Descripción" v-model="description"></textarea>
                          </div>
                        </div>
                        
                        <div class="flex flex-col px-10 xl:px-0" v-if="files.length > 0">
                          <table class="min-w-full">
                              <thead>
                                <tr>
                                  <th
                                    class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-gray-500 uppercase border border-gray-200 bg-gray-50"
                                  >Fecha/Hora</th>
                                  <th
                                    class="items-center px-6 py-3 text-xs font-medium leading-4 tracking-wider text-gray-500 uppercase border border-gray-200 bg-gray-50"
                                  >Documento
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="bg-white">
                                <tr v-for="f in files" :key="f.id">
                                  <td class="px-6 py-3 text-xs whitespace border-b border-gray-200">
                                    {{ f.created_at | fechaHora }}
                                  </td>
                                  <td class="px-6 py-3 text-xs whitespace border-b border-gray-200">
                                    <div class="flex flex-row">
                                      <span class="pr-2">
                                          {{ f.name }}
                                      </span>
                                      <span class="flex items-center">
                                        <a href="#" @click="downloadFile(f.file, f.name, '')" class="pr-1">
                                          <svg
                                            class="w-5 h-5 mr-2 -ml-1 text-blue-500"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                            </path>
                                          </svg>
                                        </a>
                                      </span>
                                      <span class="flex items-center" v-if="f.sign">
                                        <a href="#" @click="downloadFile(f.sign, f.name, '_signature')">
                                          <svg
                                            class="w-5 h-5 mr-2 -ml-1 text-green-500"
                                            fill="currentColor"
                                            viewBox="0 0 20 20"
                                          >
                                            <path d="M18.303,4.742l-1.454-1.455c-0.171-0.171-0.475-0.171-0.646,0l-3.061,3.064H2.019c-0.251,0-0.457,0.205-0.457,0.456v9.578c0,0.251,0.206,0.456,0.457,0.456h13.683c0.252,0,0.457-0.205,0.457-0.456V7.533l2.144-2.146C18.481,5.208,18.483,4.917,18.303,4.742 M15.258,15.929H2.476V7.263h9.754L9.695,9.792c-0.057,0.057-0.101,0.13-0.119,0.212L9.18,11.36h-3.98c-0.251,0-0.457,0.205-0.457,0.456c0,0.253,0.205,0.456,0.457,0.456h4.336c0.023,0,0.899,0.02,1.498-0.127c0.312-0.077,0.55-0.137,0.55-0.137c0.08-0.018,0.155-0.059,0.212-0.118l3.463-3.443V15.929z M11.241,11.156l-1.078,0.267l0.267-1.076l6.097-6.091l0.808,0.808L11.241,11.156z"></path>
                                          </svg>
                                        </a>
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                      </div>
                    </div>
                </div>
                
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                    <button 
                        @click="closeModal"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >  
                            <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                            </path>
                        </svg>
                        Cancelar
                    </button>
                </span>
                
                <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                    <button 
                        @click="confirm"
                        :disabled="loading"
                        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
                        type="button" 
                        class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                        <svg
                            class="w-5 h-5 mr-2 -ml-1 text-white-400"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                            </path>
                        </svg>
                        Aceptar
                    </button>
                </span>
            </div>
        </div>  
    </div>      
  </div>
</template>

<script>
import Vue from 'vue'
import VueAlertify from 'vue-alertify'

Vue.use(VueAlertify)

export default {
  props: {
      claim: {},
      modal: false,
  },

  data() {
    return {
      loading: false,
      file: null,
      files: [],
      name: null,
      description: null,
      errors: {
        file: null
      }
    }
  },

  watch: {
    modal (value) {
      if (value) {
        this.getFiles()
      }
    }
  },

  methods: {
    closeModal() {
      this.cleansForm()
      this.cleansErrors()
      this.$emit('closeModal')
    },
    cleansForm() {
      this.file = null
      this.name = null
      this.description = null
    },
    cleansErrors() {
        this.errors = {
            file: null,
            name: null
        }
    },
    validate(){
      this.cleansErrors()
      let valid = true

      if (this.name == null || this.name == ""){
        this.errors.name = "Nombre Requerido!"
        valid = false
      }

      if (this.file == null){
        this.errors.file = "Adjunto Requerido!"
        valid = false
      }

      return valid
    },
    handleFile(e) {
      const selected = e.target.files[0]
      const reader = new FileReader()
      reader.onload = (e) => {
        this.file = e.target.result
      }
      reader.readAsDataURL(selected)
    },
    async confirm() {
      if (this.validate()){
        try {
            this.loading = true
            const params = {
              name: this.name,
              description: this.description,
              file: this.file
            }

            await this.$http.put(`/claims/${this.claim.id}/sign/file`, params)
            this.$alertify.success('Documento enviado a firmar!') 
            this.loading = false
            this.$refs.inputFile.value=null
            this.cleansForm()
            this.cleansErrors()
            this.getFiles()
        } catch (error) {
            this.loading = false
            this.$alertify.error('ERROR. No se ha podido adjuntar el documento!')
        } 
      }
    },
    async getFiles(){
      const resp = await this.$http.get(`/claims/${this.claim.id}/sign/files`)
      this.files = resp.files
    },
    downloadFile(file, name, str){
      const linkSource = file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = name+str
      downloadLink.click();
    }
  }
}
</script>

